export default {
  "content": "<path d=\"M15.45 9.75l1.05 1.02-5.86 5.73-3.14-3.07 1.05-1.02 2.09 2.05 4.81-4.71z\"/><path fill-rule=\"evenodd\" d=\"M18.75 3A2.26 2.26 0 0121 5.25v13.5A2.26 2.26 0 0118.75 21H5.25A2.25 2.25 0 013 18.75V5.25C3 4.01 4 3 5.25 3h13.5zM5.25 18.75h13.5V8.62H5.25v10.13z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};